import {MdMyLocation} from "react-icons/md";

/**
 * Zwraca ikonę do przycisku lokalizacji użytkownika
 * @returns {JSX.Element}
 */
export default function Locate() {
    return <MdMyLocation/>
}
